import sleep from "sleep-promise";
import { EntityRepository } from "./entity_repository";
import { performApiRequest } from "@/utils/api";
import { Entity } from "./entity";


export class SyncManager {
    url: string;
    args: any;
    repositoryMapping: {[key: string]: EntityRepository<any>};
    _syncPromise: any = null;

    constructor(
        url: string,
        args: any,
        repositoryMapping: {[key: string]: EntityRepository<any>}
    ) {
        this.url = url;
        this.args = args;
        this.repositoryMapping = repositoryMapping;
    }

    get isSyncing(): boolean {
        for (let repoName in this.repositoryMapping) {
            let repo = this.repositoryMapping[repoName];
            if (repo.changed.length) {
                return true;
            }
        }
        return false;
    }

    async _sync() {
        while (true) {
            let payload: {[key: string]: any[]} = {},
                entities: {[key: string]: {[key: string]: Entity<any>}} = {},
                needSync = false;

            for (let repoName in this.repositoryMapping) {
                let repo = this.repositoryMapping[repoName];
                if (repo.changed.length) {
                    needSync = true;
                    for (let entity of repo.changed) {
                        if (payload[repoName] === undefined) {
                            payload[repoName] = [];
                            entities[repoName] = {};
                        }
                        if (entity.localValue) {
                            (entity.localValue as any).updated_at = (Date.now() + repo.timeDiff) / 1000;
                        }
                        payload[repoName].push(entity.value);
                        entities[repoName][entity.id] = entity;
                    }
                }
            }
            if (needSync) {
                for (let repoName in entities) {
                    this.repositoryMapping[repoName].freeze();
                }
                try {
                    let response = await performApiRequest(this.url, "POST", payload, this.args);
                    for (let repoName in response) {
                        let updatedEntities = response[repoName];
                        for (let updatedEntityData of updatedEntities) {
                            let entity = entities[repoName][updatedEntityData[this.repositoryMapping[repoName].primaryKey]];
                            entity.updateRemote(updatedEntityData, this.repositoryMapping[repoName].isFrozen);
                            if (updatedEntityData.updated_at >= entity.value.updated_at) {
                                entity.revert();
                            }
                        }
                    }
                } catch (e) {
                    console.log(e)
                }
            }
            for (let repoName in this.repositoryMapping) {
                let repo = this.repositoryMapping[repoName];
                if (repo.changed.length == 0) {
                    repo.reset();
                }
            }
            await sleep(2000);
        }
    }

    start() {
        if (this._syncPromise == null) {
            this._syncPromise = this._sync();
        }
    }

    stop() {
        if (this._syncPromise != null) {
            this._syncPromise.cancel();
            this._syncPromise = null;
        }
    }
}
